import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';

import { ConnectionAlertService } from '../components/connection-alert';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly connectionAlertService: ConnectionAlertService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0 && !Capacitor.isNativePlatform()) {
          this.connectionAlertService.show();
        }
        return throwError(() => error);
      }));
  }
}
